import { render } from "./AgentSquare.vue?vue&type=template&id=5a71c2da"
import script from "./AgentSquare.vue?vue&type=script&lang=js"
export * from "./AgentSquare.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__